import type { FeatureFlags } from '#types'

export const useFeatureFlags = () => {
    const { public: { flags } } = useRuntimeConfig()

    return flags as FeatureFlags
}
